import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
//import axios from 'axios';
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useExtrasRatesLogic from "./useExtrasRatesLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "addon", label: "Extra", allowSorting: true, subvalue: "name" },
  {
    field: "season",
    label: "Season",
    allowSorting: true,
    subvalue: "Name",
    showInFilter: true,
  },
  {
    field: "currency",
    label: "Currency",
    allowSorting: true,
    subvalue: "code",
  },
  { field: "is_fixed_rate", label: "Is fixed rate", allowSorting: true },
  { field: "daily_rate", label: "Daily rate", allowSorting: true },
  { field: "weekly_rate", label: "Weekly rate", allowSorting: true },
  { field: "monthly_rate", label: "Monthly rate", allowSorting: true },
];

const ExtrasRatesPage = () => {
  const { apiRoute, addRoles, deleteRoles, editRoles, initFields } =
    useExtrasRatesLogic();

  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];

      //API endpoint to fetch the data
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(
          config,
          "seasons",
          "season",
          temp,
          "Name",
          "branch"
        ),
        fetchDataAndMapToField(config, "addons", "addon", temp),
        fetchDataAndMapToField(
          config,
          "currencies",
          "currency",
          temp,
          "code",
          "symbol"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  useEffect(() => {
    loadOptions();
  }, []);

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to Extras Rates" />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        tableNameInDb={"extras_rate"}
        apiRoute={apiRoute}
        bringFormData={loadOptions}
        columns={columns}
        fields={fields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        hasImport={true}
        importConfig={{
          relationshipMappings: [
            { field: "addon", lookupTable: "addons", lookupField: "name" },
            { field: "season", lookupTable: "season", lookupField: "Name" },
            { field: "currency", lookupTable: "currency", lookupField: "code" }
          ]
        }}
        enhancedTable={true}
      />
    </div>
  );
};

export default ExtrasRatesPage;
